<template>
<div class="sidenavright-menu fullheight">
  <div class="sidenavright-content slidemap">
      <div class="pill-header">
        <div class="row no-margin">
          <div class="col no-padding">
            <div class="pill-title">
              {{selectedTrip.trip_id}}
            </div>
          </div>
          <div class="col-md-auto no-padding bgclose">
            <div class="close-sidebar">
              <svgicon name="cancelwhite" width="14" height="14"
              :original="true" @click="closeMenu" />
            </div>
          </div>
        </div>
      </div>
      <div class="pill-body">
        <div class="pill-row">
          <div class="tab-body">
            <div class="row mb-1">
              <div class="col-md-6">
                <div class="pill-sectext">{{selectedTrip.route}}</div>
                <div class="pill-sectext">{{selectedTrip.createdAt}}</div>
                <div class="pill-sectext">Telecom Partner JIO - {{selectedTrip.isJio}}</div>
              </div>
              <div class="col-md-6">
                <div class="pill-sectext">Truck Number - {{selectedTrip.truck_number}}</div>
                <div class="pill-sectext">Driver Number - {{selectedTrip.driver_number}}</div>
                <div class="pill-sectext">Reference ID - {{selectedTrip.customer_reference}}</div>
              </div>
            </div>
            <iframe v-if="!showLoading && tripDetails.locations && tripDetails.locations.length" :src="trackUrl()" frameborder="0" style="border:0" width="560px" height="450px"/>
            <div v-else class="centerblockimg valign-middle">
              <svgicon name="emptylocation" width="200" height="200"
              :original="true" />
            </div>
            <div v-if="showLoading" class="centerblockimg valign-middle">
              <svgicon name="loadingmap" width="200" height="200"
              :original="true" />
            </div>
          </div>
        </div>
      </div>
      <div class="formfooter" v-if="checkStatus() && $hasPermission('update_tracking')">
        <div class="btnaction">
          <button type="button" class="btn section_pbtn" v-if="!trackFormLoading" @click="$emit('endTrip')">End Trip</button>
        </div>
      </div>
  </div>
</div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex';

import { mapType } from 'pando-constants';

export default {
  props: ['selectedTrip'],
  computed: {
    ...mapGetters({
      showLoading: 'tracking/showLoading',
      tripDetails: 'tracking/tripDetails',
      trackFormLoading: 'tracking/trackFormLoading',
      currentClientConfig: 'app/currentClientConfig',
      environmentVariables: 'app/environmentVariables',
    }),
    selectedCategory() {
      return this.Menu[1];
    },
    mapConfig() {
      return (this.currentClientConfig && this.currentClientConfig.map_configuration);
    },
  },
  methods: {
    closeMenu() {
      this.$emit('close');
      this.$store.commit('tracking/TRIP_DETAILS', { data: [] });
    },
    // TODO need to move common function
    trackUrl() {
      this.tripDetails.mapSettings = this.environmentVariables && this.environmentVariables.map_settings;
      this.$session.set('tripDetails', this.tripDetails);
      let url = `${window.location.origin}/map`;
      if (this.mapConfig.type && this.mapConfig.type === mapType().HERE_MAP) {
        const apiKey = this.environmentVariables.hm_key;
        url = `${window.location.origin}/hereMap?apiKey=${apiKey}`;
      }
      return url;
    },
    checkStatus() {
      const status = this.selectedTrip.status;
      return ['PENDING', 'STARTED'].includes(status);
    },
  },
};
</script>

<style lang="scss" scoped>
.track {
    //border: 1px solid #E8E8E8;
    &-map {
        display: inline-block;
        float: left;
    }
}
.sectitle {
  display: block;
  margin-top: 15px;
  font-family: 'OpenSans-Regular';
  font-size: 1.2rem;
  color: #A3A3A3;
}
</style>
